import { api } from "./base.api.ts"

export const editCustomer = async (updateData) => {
  await api.post("edit-customer", updateData)
}
